export default "__VITE_ASSET__81df2b48__"